export default __webpack_public_path__ + "static/media/01.a85a3536.jpg";